import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import dataProject from './utils/projects-handler/dataProject';
import dataBlog from './utils/blog-handler/dataBlog';
import projectsRoutesRender from './utils/projectsRoutesRender';
import blogRoutesRender from './utils/blogRoutesRender';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import ProjectsPage from './pages/ProjectsPage';
import BlogPage from './pages/BlogPage';

const App = () => {
  const [ alert, setAlert ] = useState(true);

  useEffect(() => {
    const init = localStorage.getItem("init")
    const longListArticle = localStorage.getItem("longListArticle")
    const longListProject = localStorage.getItem("longListProject")

    if (alert) {
      localStorage.removeItem("init")
      localStorage.removeItem("longListArticle")
      localStorage.removeItem("longListProject")
    }
  }, [])

  return ( 
    <Grid item container justifyContent="center" className="AppMain">
      <Router>       
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage alert={alert} setAlert={setAlert} />} />
            {
              dataProject.map( element => projectsRoutesRender(element) )
            }
            {
              dataBlog.map( element => blogRoutesRender(element) )
            }
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </Grid>
  );
}

export default App;
